import axios from "axios";
import React, {useEffect, useState} from "react";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from '../Univ';
function AddWorker() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        mobile: "",
        address: "",
        pincode: "",
        work_type: [],
        availability: true,
        cost: "",
        unit: ""
    });
    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };
    const handleCheckboxChange = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            setFormData({
                ...formData,
                work_type: [...formData.work_type, value]
            });
        } else {
            setFormData({
                ...formData,
                work_type: formData.work_type.filter(item => item !== value)
            });
        }
    };
    // ==========================
    // SUBMIT USING FORMDATA
    // ==========================
    const formSubmit = (e) => {
        e.preventDefault();
        if (!formData.mobile || !formData.work_type) {
            Swal.fire("Error", "Fill required fields", "error");
            return;
        }
        if (
            !formData.mobile ||
            formData.work_type.length === 0 ||
            !formData.unit
        ) {
            Swal.fire("Error", "Fill all required fields", "error");
            return;
        }
        const fd = new FormData();
        fd.append("name", formData.name);
        fd.append("mobile", formData.mobile);
        fd.append("address", formData.address);
        fd.append("pincode", formData.pincode);
        fd.append("work_type", formData.work_type.join(","));
        fd.append("availability", formData.availability);
        fd.append("cost", formData.cost);
        fd.append("unit", formData.unit);
        fd.append("status", "1");
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        axios.post(baseUrl + "worker/create/", fd)
            .then(() => {
                Swal.fire("Success", "Worker Added", "success");
                window.location.reload();
            })
            .catch(() => {
                Swal.fire("Error", "Something went wrong", "error");
            });
    };
    // ==========================
    // FETCH DATA
    // ==========================
    const fetchData = () => {
        setLoading(true);
        axios.get(baseUrl + "worker/create/")
            .then(res => {
                setRows(res.data);
                setLoading(false);
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    // ==========================
    // DELETE
    // ==========================
    const handleDelete = (id) => {
        Swal.fire({
            title: "Confirm",
            text: "Are you sure you want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(baseUrl + "delete-worker/" + id + "/")
                    .then(() => {
                        Swal.fire("Deleted", "Worker Deleted", "success");
                        fetchData();
                    })
                    .catch(() => {
                        Swal.fire("Error", "Delete Failed", "error");
                    });
            }
        });
    };
    // ==========================
    // TABLE COLUMNS
    // ==========================
    const columns = [
        {field: "id", headerName: "ID", width: 80},
        {field: "name", headerName: "Name", width: 150},
        {field: "mobile", headerName: "Mobile", width: 150},
        {field: "work_type", headerName: "Work Type", width: 150},
        {field: "pincode", headerName: "Pincode", width: 120},
        {field: "cost", headerName: "Cost", width: 120},
        {field: "unit", headerName: "Unit", width: 120},
        {
            field: "delete",
            headerName: "Action",
            width: 100,
            renderCell: (params) => (
                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(params.row.id)}
                >
                    Delete
                </button>
            )
        }
    ];
    // ==========================
    // UI
    // ==========================
    return (
        <section className="container mt-4">

            <div className="card">
                <h4 className="card-header">Add Worker</h4>

                <div className="card-body">
                    <input
                        name="name"
                        placeholder="Name"
                        className="form-control mb-2"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <input
                        type="number"
                        name="mobile"
                        placeholder="Mobile"
                        className="form-control mb-2"
                        value={formData.mobile}
                        onChange={handleChange}
                    />

                    <input
                        name="address"
                        placeholder="Address"
                        className="form-control mb-2"
                        value={formData.address}
                        onChange={handleChange}
                    />

                    <input
                        type="number"
                        name="pincode"
                        placeholder="Pincode"
                        className="form-control mb-2"
                        value={formData.pincode}
                        onChange={handleChange}
                    />

                    <label className="mb-1">
                        <b>Work Type</b>
                    </label>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            value="Food Grain"
                            className="form-check-input"
                            onChange={handleCheckboxChange}
                            checked={formData.work_type.includes("Food Grain")}
                        />
                        <label className="form-check-label">Food Grain</label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            value="Pulses"
                            className="form-check-input"
                            onChange={handleCheckboxChange}
                            checked={formData.work_type.includes("Pulses")}
                        />
                        <label className="form-check-label">Pulses</label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            value="Cash Crops"
                            className="form-check-input"
                            onChange={handleCheckboxChange}
                            checked={formData.work_type.includes("Cash Crops")}
                        />
                        <label className="form-check-label">Cash Crops</label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            value="Horticultural Crop"
                            className="form-check-input"
                            onChange={handleCheckboxChange}
                            checked={formData.work_type.includes("Horticultural Crop")}
                        />
                        <label className="form-check-label">Horticultural Crop</label>
                    </div>

                    <div className="form-check">
                        <input
                            type="checkbox"
                            value="Plantation Crop"
                            className="form-check-input"
                            onChange={handleCheckboxChange}
                            checked={formData.work_type.includes("Plantation Crop")}
                        />
                        <label className="form-check-label">Plantation Crop</label>
                    </div>
                    <div className="mt-2">
                        <b>Selected:</b> {formData.work_type.join(", ")}
                    </div>
                    <input
                        type="number"
                        name="cost"
                        placeholder="Cost"
                        className="form-control mb-2"
                        value={formData.cost}
                        onChange={handleChange}
                    />

                    <select
                        name="unit"
                        className="form-control mb-2"
                        value={formData.unit}
                        onChange={handleChange}
                    >
                        <option value="">Select Unit</option>
                        <option value="Per Day">Per Day</option>
                        <option value="Per Acre">Per Acre</option>
                        <option value="Per Hectare">Per Hectare</option>
                        <option value="Per Task">Per Task</option>
                        <option value="Contract Basis">Contract Basis</option>
                    </select>
                    <button onClick={formSubmit} className="btn btn-primary">
                        Submit
                    </button>

                </div>
            </div>

            <ERPDataGrid
                sx={{
                    boxShadow: 4,
                    border: 4,
                    borderColor: 'primary.light',
                    '& .MuiDataGrid-cell:hover': {
                        color: 'primary.main',
                    },
                }}
                className="mt-4"
                rows={rows}
                columns={columns}
                loading={loading}

                autoHeight
            />

        </section>
    );
}
export default AddWorker;
